
import React from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Box,
  Stack
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";


const AddNewVehicleModal = ({ isOpen, onClose  }) => {
            const navigate = useNavigate();

  const handleAddVehicle = (inTransit) => {
    
    

    if (inTransit) {
     navigate('/VehicleaddEdit', { state: { inTransit: true } });   

    }    else {
     navigate('/VehicleaddEdit', { state: { inTransit: false } });   
    }


    onClose(); // Close the modal after adding
  };

  return (
    <>
      <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        Add New Vehicle
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Please choose if the vehicle exists in the warehouse or is in transit to the warehouse.
        </DialogContentText>

        {/* Add form fields for vehicle details here */}
      </DialogContent>

      <DialogActions>
        <Box sx={{ width: "100%" }}>
          <Stack direction="row" spacing={2} justifyContent="center" sx={{ px: 2, pb: 2 }}>
            <Button onClick={() => handleAddVehicle(true)} variant="b2" color="primary">
              In Transit to the Warehouse
            </Button>
            <Button onClick={() => handleAddVehicle(false)} variant="b1" color="primary">
              Exists in the Warehouse
            </Button>
          </Stack>
        </Box>
      </DialogActions>
    </Dialog>
    </>
  );



 
    // eslint-disable-next-line no-unreachable
    AddNewVehicleModal.displayName = "AddNewVehicleModal";
    // PropTypes for the component
    // This helps in type-checking the props passed to the component
    AddNewVehicleModal.propTypes = {
      isOpen: PropTypes.bool.isRequired,
      onClose: PropTypes.func.isRequired,
    };

};

export default AddNewVehicleModal;